

export class CityOutputWithOutStatus implements ICityOutputWithOutStatus {
    /** The auto-generated id of the city master */
    city_id!: number;
    /** The city name with 255 character limit */
    city_name!: string;

    constructor(data?: ICityOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city_id = _data["city_id"];
            this.city_name = _data["city_name"];
        }
    }

    static fromJS(data: any): CityOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CityOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city_id"] = this.city_id;
        data["city_name"] = this.city_name;
        return data; 
    }
}

export interface ICityOutputWithOutStatus {
    /** The auto-generated id of the city master */
    city_id: number;
    /** The city name with 255 character limit */
    city_name: string;
}

